
<template>
  <div>
    <!-- <el-dialog title="物流跟踪信息页面" :visible.sync="dialogVisible" width="1000px">
      eee
    </el-dialog> -->
    <!-- <el-dialog
      title="物流跟踪信息"
      :visible.sync="dialogVisible"
      width="520px"
      top="15px"
    >
      <div
        style="max-height: 800px;min-height: 200px;overflow-y: auto"
      >
        <div style="margin-left: 60px">
          <rj-timeline class="Processing">
            <rj-timeline-item
              :color="index != 0 ? '#909399' : ''"
              v-for="(pro, index) in Processing.traces"
              :key="index"
            >
              <p>{{ pro.acceptStation }}</p>
              <p>{{ pro.acceptTime }}</p>
              <div class="itemState" v-if="index == 0">
                {{ $store.state.enumeration.LogisticsStatus[Processing.state] }}
              </div>
            </rj-timeline-item>
          </rj-timeline>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog
      title="物流跟踪信息"
      :visible.sync="dialogVisible"
      width="520px"
      top="15px"
      @open="open"
    >
      <div
        v-loading="ProcessingLoading"
        style="max-height: 800px;min-height: 200px;overflow-y: auto"
      >
        <el-divider content-position="left">
          境内段物流信息
        </el-divider>
        <div v-if="Processing.logisticCode" style="margin: 10px 0">
          <span>运单号：{{ Processing.logisticCode }}</span>
        </div>
        <div style="margin-left: 60px">
          <rj-timeline class="Processing">
            <rj-timeline-item
              v-for="(pro, index) in Processing.traces"
              :key="index"
              :color="index != 0 ? '#909399' : ''"
            >
              <p>{{ pro.acceptStation }}</p>
              <p>{{ pro.acceptTime }}</p>
              <div v-if="index == 0" class="itemState">
                {{ $store.state.enumeration.LogisticsStatus[Processing.state] }}
              </div>
            </rj-timeline-item>
          </rj-timeline>
        </div>
        <no-data v-if="!Processing.logisticCode" />
        <div>
          <el-divider content-position="left">
            境外段物流信息
          </el-divider>
          <div class="rj-row">
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  派送日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ intelLogisticsInfo.deliveryDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  清关日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ intelLogisticsInfo.customsClearanceDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  抵港日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ intelLogisticsInfo.arrivalDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  离境日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ intelLogisticsInfo.departureDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  报关日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ intelLogisticsInfo.customsDeclarationDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  提货日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ intelLogisticsInfo.pickUpDate || "--" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import noData from '@/components/noData';
import timeLine from 'rjelement-components/packages/components/timeLine';
import timeLineItem from 'rjelement-components/packages/components/timeLineItem';
import { getLogisticsInfoToList } from '@/API';
import { getIntelLogisticsDetailByFhNum } from '@/API/international';
export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisibleLogist,
      intelLogisticsInfo: {},
      ProcessingLoading: false,
      Processing: { 'shipperCode': '', 'logisticCode': 'JDVC06786359848', 'success': true, 'reason': '', 'state': 4, 'traces': [{ 'acceptTime': '2021-01-07 20:14:42', 'acceptStation': '您的快件已签收，感谢您使用京东物流，期待再次为您服务。', 'remark': '' }, { 'acceptTime': '2021-01-07 09:21:51', 'acceptStation': '您的快件由【天津武清转运中心】准备发往【天津城配车队】', 'remark': '' }, { 'acceptTime': '2021-01-07 09:21:46', 'acceptStation': '您的快件在【天津武清转运中心】分拣完成', 'remark': '' }, { 'acceptTime': '2021-01-07 08:54:21', 'acceptStation': '【天津货嘀嘀物联科技有限公司】您的快件正在派送中，请您准备签收（快递员：货嘀嘀解明辉，联系电话：15822241557）', 'remark': '' }, { 'acceptTime': '2021-01-06 15:25:28', 'acceptStation': '您的快件已到达【天津武清转运中心】', 'remark': '' }, { 'acceptTime': '2021-01-05 05:50:54', 'acceptStation': '您的快件已发车', 'remark': '' }, { 'acceptTime': '2021-01-05 04:00:17', 'acceptStation': '您的快件由【泉州转运中心】准备发往【天津武清转运中心】', 'remark': '' }, { 'acceptTime': '2021-01-05 04:00:12', 'acceptStation': '您的快件在【泉州转运中心】分拣完成', 'remark': '' }, { 'acceptTime': '2021-01-05 03:11:50', 'acceptStation': '您的快件已到达【泉州转运中心】', 'remark': '' }, { 'acceptTime': '2021-01-04 22:38:37', 'acceptStation': '您的快件已发车', 'remark': '' }, { 'acceptTime': '2021-01-04 22:38:32', 'acceptStation': '快递司机收箱', 'remark': '' }, { 'acceptTime': '2021-01-04 19:34:35', 'acceptStation': '您的快件已到达【福州锐捷B驻场】', 'remark': '' }, { 'acceptTime': '2021-01-04 19:34:34', 'acceptStation': '您的快件已由【福州锐捷B驻场】揽收完成', 'remark': '' }, { 'acceptTime': '2021-01-04 19:34:34', 'acceptStation': '京东快递 已收取快件', 'remark': '' }] }
    };
  },
  props: {
    dialogFormVisibleLogist: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    noData,
    'rj-timeline': timeLine,
    'rj-timeline-item': timeLineItem
  },
  methods: {
    open () {
      this.initData(this.form.logisticsNum, this.form.invoiceNum, this.form.logisticsCompany);
    },
    initData (val, invoiceNumber, logisticsCompany) {
      if (val) {
        this.Processing = {
          traces: []
        };
        this.ProcessingVisible = true;
        this.ProcessingLoading = true;
        getLogisticsInfoToList(val, logisticsCompany || '').then((res) => {
          let json = res.data;
          this.ProcessingLoading = false;
          if (json.status === '200') {
            this.Processing = json.data;
          }
        }).catch(() => {
          this.ProcessingLoading = false;
        });
      }
      if (invoiceNumber) {
        this.intelLogisticsInfo = {
        };
        getIntelLogisticsDetailByFhNum(invoiceNumber).then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data !== null) {
            this.intelLogisticsInfo = json.data;
          }
        }).catch(() => {
          this.ProcessingLoading = false;
        });
      }
    }
  },
  watch: {
    dialogFormVisibleLogist (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  mounted () {

  }

};
</script>

<style>

</style>
